import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/index/index"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/about/index"),
  },
  {
    path: "/productCase/:parentId",
    name: "ProductCase",
    props: true,
    component: () => import("@/views/productCase/index"),
  },
  {
    path: "/productCase/detail/:parentId/:caseId",
    name: "ProductCaseDetail",
    props: true,
    component: () => import("@/views/productCase/caseDetail"),
  },
  {
    path: "/joinUs",
    name: "joinUs",
    component: () => import("@/views/join/index"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
